import { render, staticRenderFns } from "./Tamponi.vue?vue&type=template&id=06c6e15c&"
import script from "./Tamponi.vue?vue&type=script&lang=ts&"
export * from "./Tamponi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports